import createFusionProfileAtom from './fusion-profile.js'
import createLocalProfileAtom from './local-profile.js'

export const fusionProfileAtomDefinition = {
  id: 'fusionProfileAtom',
  type: 'atom',
  factory: createFusionProfileAtom,
  dependencies: ['fusion', 'logger'],
  public: true,
}

export const localProfileAtomDefinition = {
  id: 'profileAtom',
  type: 'atom',
  factory: createLocalProfileAtom,
  dependencies: ['storage', 'config'],
  public: true,
}
